import { render, staticRenderFns } from "./subject_frequency_form.vue?vue&type=template&id=63cbf228&"
import script from "./subject_frequency_form.vue?vue&type=script&lang=js&"
export * from "./subject_frequency_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports